import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueIncludes'
})
export class ValueIncludesPipe implements PipeTransform {

  transform(value, values: string[] | string, affirm = true): boolean {
    let includes = false;
    if(!value || typeof value !== "string") return false;
    if(Array.isArray(values)) values?.forEach(v => includes = includes || 
      (
        v?.toString()?.includes(".")? v?.toString()?.toLowerCase()?.replace('.','') === value?.toString()?.toLowerCase() :
        value?.toString()?.toLowerCase()?.includes(v?.toString()?.toLowerCase())
      )
    );
    
    else includes = values?.toString()?.includes(".")? values?.toString()?.toLowerCase()?.replace('.','') === value?.toLowerCase() :
    value?.toString()?.toLowerCase()?.includes(values?.toLowerCase());
  
    return affirm ? includes : !includes;
  }

}
